<template>
<div>
  <div class="wistia_embed wistia_async_j31ey2m5ad">
    &nbsp;
  </div>

  <div
    id="cultivating_new_connections_choose"
    class="tbk-vid-embed"
  >
    <a
      id="kate_ruer"
      class="embedded_video"
      href="#wistia_3zuhpyl6du?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="brad_froslee"
      class="embedded_video"
      href="#wistia_utndkg07fb?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="angela_denker"
      class="embedded_video"
      href="#wistia_e3tylw12qb?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="mark_aune"
      class="embedded_video"
      href="#wistia_qaa78fry1x?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('j31', 18, this.showSelect)

    this.tbk.loadCrossTime('3zu', 89, this.showSelect)
    this.tbk.loadCrossTime('utn', 219, this.showSelect)
    this.tbk.loadCrossTime('e3t', 135, this.showSelect)
    this.tbk.loadCrossTime('qaa', 215, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '3zu': this.tbk.autoPlay,
        utn: this.tbk.autoPlay,
        e3t: this.tbk.autoPlay,
        qaa: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#cultivating_new_connections_choose
  display: none
  a
    text-decoration: none
#kate_ruer
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 54%
#brad_froslee
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 54%
#angela_denker
  position: absolute
  top: 54%
  left: 0
  width: 50%
  height: 46%
#mark_aune
  position: absolute
  top: 54%
  left: 50%
  width: 50%
  height: 46%
</style>
